import request from "@/router/axios";
export const saveWardIdles = (data) => {
  return request({
    url: `/api/bed/wardIdle/saveWardIdles`,
    method: "post",
    data,
  });
};

export const loadWardIdles = (wardId, start, end) => {
  return request({
    url: `/api/bed/wardIdle/loadWardIdles`,
    method: "get",
    params: {
      wardId,
      start,
      end,
    },
  });
};
export const saveWardIdle = (data) => {
  return request({
    url: `/api/bed/wardIdle/saveWardIdle`,
    method: "post",
    data,
  });
};
export const idleLogs = (wardId, start, end) => {
  return request({
    url: `/api/bed/wardIdleLog/list`,
    method: "post",
    data: {
      filterParams: [
        { name: "createTime", type: "between", value: start + "," + end },
        { name: "wardId", type: "", value: wardId },
      ],
      orderBy: "createTime",
      isDesc: true,
    },
  });
};
